import Articles from '@helsenorge/core-cms/articles';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';

import { useGetForsideQuery } from '../store/contentApi';
import { useAppSelector } from '../store/hooks';

import styles from './styles.module.scss';

const ArticlesContainer: React.FC = () => {
  const language = useAppSelector(state => selectCurrentLanguage(state.language));
  const { data: forside } = useGetForsideQuery(language);

  if (!forside) {
    return null;
  }

  return (
    <div className={styles.articlescontainer}>
      <div className="container">
        <div className="row">
          <div className="col">
            <Articles title={forside.articles.articlesTitle} articles={forside.articles.articleList} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticlesContainer;
